import React, { useState } from "react"
import { Collapse, IconButton, makeStyles } from "@material-ui/core";
import arrowDownIcon from "../../../images/arrow-down.svg"
import { useSelector } from "react-redux";
import { selectWorkshopSearchFilters } from "../../../redux/workshopSearch/selectors";
import { WorkshopSearchTypes } from "../../../Constantes/WorkshopSearchTypes";


const useStyles = makeStyles((theme)=>({
  root: {
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
    },
  },
  summaryRoot:{
     minHeight: "2rem",
     display: "flex",
     alignItems: "center",
    '&$expanded': {
        minHeight: "2rem",
             display: "flex",
     alignItems: "center",
    },
  },
  summaryExpanded:{
    minHeight: "min-content",
    margin: 0,
    height: "min-content",
    display: "flex",
     alignItems: "center",
    // paddingLeft: "2rem",
    color: theme.palette.primary.main
  },
  summaryContent:{
        display: "flex",
     alignItems: "center",
     margin: 0,
     backgroundColor: "red",
     '&$expanded': {
        margin: 0
     }
  }, 
  expanded: {},
}))

function WorkshopCard(props){
    const {name, address, distance, phone,id, category, cataloguing, duration} = props;
    const [open, setOpen] = useState(false)
    const searchFilter = useSelector(selectWorkshopSearchFilters);
    const searchType = searchFilter?.searchOption;

    return(
        <>
            <div role="button" onClick={()=>setOpen(!open)} className="workshop-card-header" style={open ? {paddingLeft: "2rem"} : {}}>
                <span style={{textTransform: "uppercase"}} className="workshop-card-label">{name}</span>
                {
                  searchType !== WorkshopSearchTypes.SMR &&
                  <>                
                    <span style={{textAlign: "right"}}>{`(${distance} | ${Math.round(duration/60)}min)`}</span>
                    <IconButton onClick={()=>setOpen(!open)}><img src={arrowDownIcon}/></IconButton>
                  </>
                }
            </div>
            <Collapse in={open}>
            <div>
                <span className="workshop-card-label">Dirección:</span><span>{address}</span>
                <div className="workshop-card-grid">
                    <div><span className="workshop-card-label">Tlf:</span><span>{phone}</span></div>
                    <div><span className="workshop-card-label">Categoría:</span><span>{category}</span></div>
                    <div><span className="workshop-card-label">Id:</span><span>{id}</span></div>
                    {cataloguing =="MM" || cataloguing == "SO"?
                             <div><span className="workshop-card-label">Catalogación:</span>{cataloguing}</div>
                             : <div><span className="workshop-card-label">Red:</span>{cataloguing}</div>
                    }
                </div>
            </div>
            </Collapse>
        </>
    )
}



export {WorkshopCard}